import { hotDesk, seatable } from './utils'
import get from 'lodash/get'
import groupBy from 'lodash/groupBy'

export const convertTeamSpacesToPoints = ({ ids, byId }) => {
  const sp = ids.reduce((result, id) => {
    const s = byId[id]
    return seatable(s.spaceType) || hotDesk(s.usageType) ? [...result, s] : result
  }, [])

  return sp.map((pro) => {
    const {
      x,
      y,
      w,
      code,
      spaceAssignment: { team },
    } = pro
    const point = [x, y]
    point.w = w
    point.team = team
    point.code = code
    return point
  })
}

export const groupTeamCluster = (cluster) => groupBy(cluster, ({ team }) => get(team, 'id'))
